import { IconButton } from '@mui/joy';
import { Trash } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useApprovedVendorsActions } from 'companySettings/hooks';
import { Confirmation } from 'core/components';
import { NotificationPosition } from 'core/enums';
import { Color, Size, Variant } from 'theme/enums';

export const RemoveCell = ({ data, api }: ICellRendererParams) => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const { t } = useTranslation();

  const { removeApprovedVendors } = useApprovedVendorsActions(NotificationPosition.TOP);

  const isDefault = data.isDefault;
  const sameManufacturerRows = api
    .getRenderedNodes()
    .filter((node) => node.data?.manufacturerId === data.manufacturerId);
  const allowRemove = !isDefault || sameManufacturerRows.length === 1;

  const removeLabel = t('buttonLabelRemove');

  const handleRemove = async () => {
    await removeApprovedVendors([data.id]);

    api.refreshServerSide({ purge: true });
  };

  const onClick = () => {
    if (allowRemove) {
      handleRemove();
    } else {
      setIsConfirmationOpen(true);
    }
  };

  return (
    <>
      <IconButton
        size={Size.SM}
        color={Color.DANGER}
        variant={Variant.PLAIN}
        aria-label={removeLabel}
        onClick={onClick}
      >
        <Trash />
      </IconButton>
      {/* Informational only — a default vendor sharing its manufacturer cannot be removed at all,
          so this alert deliberately has no confirm action. */}
      <Confirmation
        isOpen={isConfirmationOpen}
        title={t('titleAlertRemoveDefaultApprovedVendor')}
        message={t('messageAlertRemoveDefaultApprovedVendor')}
        onCancel={() => setIsConfirmationOpen(false)}
      />
    </>
  );
};
